import { useTranslation } from "react-i18next";
import { Phone, Mail, MapPin, Globe } from "lucide-react";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <footer
      dir={dir}
      className="relative overflow-hidden"
      style={{ background: '#2d2d2b' }}
    >
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #ffde21 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">

          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img
                src="/LiwanLogo1.webp"
                alt="LIWAN Solutions"
                className="h-16 w-auto mb-4"
                loading="lazy"
                decoding="async"
              />
              <h3
                className="text-2xl font-black mb-2"
                style={{ color: '#ffde21' }}
              >
                LIWAN Solutions
              </h3>
              <p
                className="text-lg font-semibold"
                style={{ color: 'white', opacity: 0.9 }}
              >
                {i18n.language === "ar"
                  ? "الليوان للحلول الذكية والأتمتة"
                  : "Smart Solutions & Automation"}
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4
              className="text-xl font-bold mb-6"
              style={{ color: '#ffde21' }}
            >
              {i18n.language === "ar" ? "تواصل معنا" : "Contact Us"}
            </h4>
            <div className="space-y-4">
              {/* Location */}
              <div className="flex items-start gap-3">
                <MapPin
                  size={20}
                  style={{ color: '#ffde21', marginTop: '2px', flexShrink: 0 }}
                />
                <div>
                  <p style={{ color: 'white', opacity: 0.9 }}>
                    {t("irbid")} – {t("wasfiAlTalSt")}
                  </p>
                </div>
              </div>

              {/* Phone Numbers */}
              <div className="flex items-start gap-3">
                <Phone
                  size={20}
                  style={{ color: '#ffde21', marginTop: '2px', flexShrink: 0 }}
                />
                <div className="space-y-1">
                  <p style={{ color: 'white', opacity: 0.9 }}>
                    <a
                      href="tel:+962796272614"
                      className="hover:underline transition-all duration-300"
                      style={{ color: 'white' }}
                    >
                      +962 7 96272614
                    </a>
                  </p>
                  <p style={{ color: 'white', opacity: 0.9 }}>
                    <a
                      href="tel:+962797636939"
                      className="hover:underline transition-all duration-300"
                      style={{ color: 'white' }}
                    >
                      +962 7 97636939
                    </a>
                  </p>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-3">
                <Mail
                  size={20}
                  style={{ color: '#ffde21', marginTop: '2px', flexShrink: 0 }}
                />
                <a
                  href="mailto:info@liwansolutions.com"
                  className="hover:underline transition-all duration-300"
                  style={{ color: 'white', opacity: 0.9 }}
                >
                  info@liwansolutions.com
                </a>
              </div>

              {/* Website */}
              <div className="flex items-start gap-3">
                <Globe
                  size={20}
                  style={{ color: '#ffde21', marginTop: '2px', flexShrink: 0 }}
                />
                <a
                  href="https://www.liwansolutions.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline transition-all duration-300"
                  style={{ color: 'white', opacity: 0.9 }}
                >
                  www.liwansolutions.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-xl font-bold mb-6"
              style={{ color: '#ffde21' }}
            >
              {i18n.language === "ar" ? "روابط سريعة" : "Quick Links"}
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="transition-all duration-300 hover:translate-x-2 inline-block"
                  style={{ color: 'white', opacity: 0.9 }}
                >
                  {t("home")}
                </a>
              </li>
              <li>
                <a
                  href="/services/smart-home"
                  className="transition-all duration-300 hover:translate-x-2 inline-block"
                  style={{ color: 'white', opacity: 0.9 }}
                >
                  {t("smartHomeAutomation")}
                </a>
              </li>
              <li>
                <a
                  href="/services/security"
                  className="transition-all duration-300 hover:translate-x-2 inline-block"
                  style={{ color: 'white', opacity: 0.9 }}
                >
                  {t("securityAndSurveillanceSystem")}
                </a>
              </li>
              <li>
                
              </li>
              <li>
                <a
                  href="/supplier"
                  className="transition-all duration-300 hover:translate-x-2 inline-block"
                  style={{ color: 'white', opacity: 0.9 }}
                >
                  {t("become_supplier")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          className="mt-12 pt-8 border-t text-center"
          style={{ borderColor: 'rgba(255, 222, 33, 0.2)' }}
        >
          <p style={{ color: 'white', opacity: 0.7 }}>
            {i18n.language === "ar"
              ? `© ${new Date().getFullYear()} الليوان للحلول الذكية. جميع الحقوق محفوظة.`
              : `© ${new Date().getFullYear()} LIWAN Solutions. All rights reserved.`}
          </p>
        </div>
      </div>
    </footer>
  );
}